const buttonForIntersection = document.querySelector('.brand-button--floating-observed');
const floatingButton = document.getElementById('brand-button--floating');

const observer = new IntersectionObserver(
  (entries) =>
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        floatingButton.classList.add('hide');
      } else {
        floatingButton.classList.remove('hide');
      }
    }),
  { threshold: 0.5 }
);

observer.observe(buttonForIntersection);
